import { InjectionToken } from "@angular/core";

export interface PartsApiConfig {
	portalBackendUrl?: string;
	portalApiKey?: string;
}

export const PARTS_API_CONFIG = new InjectionToken<PartsApiConfig>("PARTS_API_CONFIG");
